import createLogger from 'vuex/dist/logger';
import moment from 'moment';
import Vue from 'vue';
import Vuex from 'vuex';

import { apolloClient } from '../vue-apollo';
import { APPOINTMENT_DURATION } from '../constants/appointment';
import { DATE_FORMAT, TIME_FORMAT } from '../constants/moment';
import GET_AVAILABILITY_FOR_DAY from '../graphql/Query/GetAvailabilityForDay.gql';

Vue.use(Vuex);

const defaultAppointment = () => ({
  date: moment().format(DATE_FORMAT),
  environment: null,
  memberId: null,
  next: false,
  prev: false,
  providerId: null,
  time: null,
  title: '',
  type: null,
});

export default new Vuex.Store({
  state: {
    appointment: {
      ...defaultAppointment(),
    },
    availableDays: {
      [new Date().getFullYear()]: {}, // current year
    },
    availableTimes: {},
  },
  mutations: {
    updateAppointment(state, update) {
      state.appointment = { ...state.appointment, ...update };
    },
    updateDay(state, update) {
      state.availableDays = { ...state.day, ...update };
    },
    updateTime(state, update) {
      state.availableTimes = { ...state.time, ...update };
    },
  },
  actions: {
    async searchAvailableTimes({ commit, state }, { day }) {
      const { environment, type } = state.appointment;
      const duration = APPOINTMENT_DURATION[environment][type];
      const momentDay = moment(day, DATE_FORMAT);

      const { data } = await apolloClient.query({
        query: GET_AVAILABILITY_FOR_DAY,
        variables: {
          duration,
          date: momentDay.unix(),
        },
      });

      const hours = [
        ...new Set(data.getAvailabilityForDay.map((t) => moment.unix(t).format(TIME_FORMAT))),
      ];
      const times = hours.map((h) => moment(h, TIME_FORMAT).valueOf());

      commit('updateTime', { [day]: times });
    },
    resetAppointment({ state }) {
      state.appointment = { ...defaultAppointment() };
    },
  },
  plugins: process.env.NODE_ENV === 'development' ? [createLogger()] : [],
});
